import { render, staticRenderFns } from "./AgenceInfos.vue?vue&type=template&id=124ec182&"
import script from "./AgenceInfos.vue?vue&type=script&lang=js&"
export * from "./AgenceInfos.vue?vue&type=script&lang=js&"
import style0 from "./AgenceInfos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports